import * as schoolPortalGlobalActions from 'school-portal-actions'
import * as partnerPortalGlobalActions from 'partner-portal-actions'
import * as artistPortalGlobalActions from 'artist-portal-actions'
import { SIGN_IN_ROUTE } from 'config'
import * as routerActions from 'react-router-redux'
import { push } from 'react-router-redux'

// When a logged-out user follows a deep link (e.g. a notification email link to
// a comment/discussion), the auth guard stashes the intended path in
// `location.state.redirectUrl`. Prefer it over the portal dashboard so the user
// lands on the spot they originally requested once they sign in.
function destinationFor(redirectUrl, fallback) {
  return typeof redirectUrl === 'string' && redirectUrl.startsWith('/')
    ? redirectUrl
    : fallback
}

export function signInSuccess({
  token,
  persistSession,
  redirectUrl,
  portal, // eslint-disable-line no-unused-vars
  password, // eslint-disable-line no-unused-vars
  ...userDetails
}) {
  return function (dispatch) {
    const employmentType = userDetails.employerType

    if (employmentType === 'School') {
      dispatch(
        schoolPortalGlobalActions.setAuthenticated({ token, persistSession })
      )
      dispatch(
        schoolPortalGlobalActions.setCurrentSchoolId(
          userDetails.currentEmployerId
        )
      )
      dispatch(schoolPortalGlobalActions.setUserDetails(userDetails))
      dispatch(
        routerActions.replace(
          destinationFor(redirectUrl, '/school-portal/dashboard')
        )
      )
    } else if (employmentType === 'Organization') {
      dispatch(
        partnerPortalGlobalActions.setAuthenticated({ token, persistSession })
      )
      dispatch(
        partnerPortalGlobalActions.setCurrentPartnerId(
          userDetails.currentEmployerId
        )
      )
      dispatch(partnerPortalGlobalActions.setUserDetails(userDetails))
      dispatch(
        routerActions.replace(
          destinationFor(redirectUrl, '/partner-portal/dashboard')
        )
      )
    } else if (employmentType === 'TeachingArtist') {
      dispatch(
        artistPortalGlobalActions.setAuthenticated({ token, persistSession })
      )
      dispatch(
        artistPortalGlobalActions.setCurrentArtistId(
          userDetails?.employments[0]?.employable?.id
        )
      )
      dispatch(artistPortalGlobalActions.setUserDetails(userDetails))
      dispatch(
        routerActions.replace(
          destinationFor(redirectUrl, '/artist-portal/dashboard')
        )
      )
    } else {
      dispatch(routerActions.replace('/not-found'))
    }
  }
}

export function signUpSuccess({ redirectUrl }) {
  return function (dispatch) {
    dispatch(push(redirectUrl || SIGN_IN_ROUTE))
  }
}
